import { Flex, List, ListItem, Text } from '@opendoor/bricks/core';
import ImgixImg from 'components/shared/ImgixImg';
import React from 'react';

interface BulletItem {
  id: string;
  body: React.ReactNode;
}

interface WinningOfferContent {
  bullets: Array<BulletItem>;
}

const CONTENT: WinningOfferContent = {
  bullets: [
    {
      id: 'FALLBACK_CONTENT0',
      body: 'Tour every home on your schedule.',
    },
    {
      id: 'FALLBACK_CONTENT1',
      body: 'Get help every step of the way from a top, local agent.',
    },
    {
      id: 'FALLBACK_CONTENT2',
      body: 'Avoid paying for multiple moves and mortgages when you buy and sell with us.',
    },
  ],
};

const WinningOffer: React.FC = () => {
  const { bullets } = CONTENT;
  return (
    <Flex
      justifyContent="space-between"
      backgroundColor="neutrals10"
      alignItems="center"
      py="6"
      px="8"
      borderRadius="roundedSquare"
      gridGap="12px"
    >
      <Flex flexDirection="column">
        <Text fontWeight="semibold" fontSize="s1">
          Why buy with Opendoor
        </Text>
        <List variant="checklist">
          {bullets.map(({ id, body }: BulletItem) => {
            return (
              <ListItem key={id} fontSize="s0">
                {body}
              </ListItem>
            );
          })}
        </List>
      </Flex>
      <Flex flexShrink={0} display={['none', 'none', 'block', 'block']}>
        <ImgixImg src="9d0a022fd074439ca9990a7fd3e8bca7.svg" width={200} height={200} />
      </Flex>
    </Flex>
  );
};

export default React.memo(WinningOffer);
